<template>
    <div>
        <div>
            <button class="btn btn-default"
                    v-bind:class="{ selected:selected == 1 }"
                    @click="changeFilter('one_time'), selected = 1">
                Kertaluontoinen
            </button>
            <button class="btn btn-default"
                    v-bind:class="{ selected:selected == 2 }"
                    @click="changeFilter('recurring'), selected = 2">
                Viikottainen
            </button>
            <button class="btn btn-default"
                    v-bind:class="{ selected:selected == 3 }"
                    @click="changeFilter('ongoing'), selected = 3">
                Jatkuva
            </button>
        </div>
        <activity-card v-for="activity in this.upcomingActivities.data"
                       :key="activity.id"
                       :activity="activity">
        </activity-card>
        <pagination :data="upcomingActivities" @pagination-change-page="loadList"></pagination>
    </div>
</template>

<script>
    import axios from 'axios'
    import ActivityCard from './ActivityCard';
    import Pagination from 'laravel-vue-pagination/src/LaravelVuePagination';

    export default {
        name: "ActivityWidget",
        components: { Pagination, ActivityCard },
        data: function () {
            return {
                upcomingActivities: {},
                selectedFilter: 'one_time',
                selected: 1
            }
        },

        methods: {
            loadList: function (page = 1) {
                axios.get('/api/upcoming-activities', {
                    params: {
                        'type': this.selectedFilter,
                        'page': page
                    }
                })
                    .then((response) => {
                        this.upcomingActivities = response.data;
                    });
            },

            changeFilter: function (filter) {
                this.selectedFilter = filter;
                this.loadList()
            },

        },

        mounted: function () {
            this.loadList();
        },
    }
</script>

<style scoped>

    .selected {
        background: #d3d3d1;
    }

</style>
